<template>
  <v-app>
    <div class="login">
      <SecondaryNav />
      <div class="wrapper">
        <FlashMessages />
        <div class="my-3 logo">
          <img src="@assets/images/logos/cperi.png" alt="" />
        </div>
        <div class="text-center mt-4 name">Welcome</div>

        <v-form
          @submit.prevent="form.post($routes.user_session())"
          class="p-3 mt-3"
        >
          <div class="form-field d-flex align-items-center">
            <input
              id="email"
              v-model="form.user.email"
              type="email"
              name="userMail"
              placeholder="Enter email"
              required
            />
          </div>
          <div class="form-field d-flex align-items-center">
            <input
              id="password"
              v-model="form.user.password"
              name="password"
              placeholder="Enter password"
              type="password"
              required
            />
          </div>
          <v-checkbox
            id="remember_me"
            class="checkbox"
            v-model="form.user.remember_me"
            name="remember_me"
            label="Remember me"
          >
          </v-checkbox>

          <v-btn class="btn" type="submit" variant="tonal">Login</v-btn>
        </v-form>
      </div>
      <div style="position: absolute; bottom: 0; width: 100%">
        <SecondaryFooter />
      </div>
    </div>
  </v-app>
</template>

<script setup>
import { useForm } from "@inertiajs/vue3";
import FlashMessages from "@/Shared/FlashMessages.vue";
import SecondaryNav from "../../Shared/SecondaryNav.vue";
import SecondaryFooter from "../../Shared/SecondaryFooter.vue";

const form = useForm({
  user: {
    email: "",
    password: "",
    remember_me: null,
  },
});
</script>

<style lang="css" scoped>
.login {
  color: white;
  background-image: url("@assets/images/logos/beautiful-milky-way-night-sky.jpg");
  background-size: cover;
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: auto;
  top: 0px;
  left: 0px;
  font-size: 20px;
}

.wrapper {
  max-width: 350px;
  min-height: 500px;
  margin: 120px auto;
  padding: 40px 30px 30px 30px;
  background-color: #ecf0f3;
  border-radius: 15px;
}

.logo {
  width: 80px;
  margin: auto;
}

.logo img {
  width: 100%;
  height: 80px;
  object-fit: contain;
  border-radius: 20%;
  box-shadow: 0px 0px 3px #5f5f5f, 0px 0px 0px 5px #ecf0f3, 8px 8px 15px #a7aaa7,
    -8px -8px 15px #fff;
}

.wrapper .name {
  font-weight: 600;
  font-size: 1.4rem;
  letter-spacing: 1.3px;
  padding-left: 10px;
  color: #555;
}

.wrapper .form-field input {
  width: 100%;
  display: block;
  border: none;
  outline: none;
  background: none;
  font-size: 1.2rem;
  color: #666;
  padding: 10px 15px 10px 10px;
  /* border: 1px solid red; */
}

.wrapper .form-field {
  padding-left: 10px;
  margin-bottom: 20px;
  border-radius: 20px;
  box-shadow: inset 8px 8px 8px #cbced1, inset -8px -8px 8px #fff;
}

.wrapper .form-field .fas {
  color: #555;
}

.wrapper .btn {
  box-shadow: none;
  width: 100%;
  height: 40px;
  background-color: #03a9f4;
  color: #fff;
  border-radius: 25px;
  box-shadow: 3px 3px 3px #b1b1b1, -3px -3px 3px #fff;
  letter-spacing: 1.3px;
}

.wrapper .btn:hover {
  background-color: #039be5;
}

.wrapper a {
  text-decoration: none;
  font-size: 0.8rem;
  color: #03a9f4;
}
.wrapper .checkbox {
  color: #666;
}

@media (max-width: 1300px) {
  .wrapper {
    zoom: 65%;
  }
}
</style>
